export class AsiTableRequest {
  pageIndex: number;
  nbElementsParPage: number;
  tri: string;
  asc: boolean;
}
